/**
 * Injects a JSON-LD <script> tag into <head> via useHead.
 *
 * Pass any schema.org-shaped object — the composable wraps it in a typed
 * script tag the search engines pick up. Multiple calls on the same page
 * stack (each gets its own script tag) so a blog post can declare an
 * Article schema plus a BreadcrumbList in the same setup.
 *
 * Why a composable: useSeoMeta doesn't cover script tags, and useHead's
 * `script[type=application/ld+json]` recipe is fiddly enough to centralise.
 */
export const useStructuredData = (schema: Record<string, unknown>) => {
  useHead({
    script: [
      {
        type: 'application/ld+json',
        // Server-rendered JSON. Use textContent rather than innerHTML so
        // string escaping is handled correctly by the head manager.
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          ...schema,
        }),
      },
    ],
  })
}

/**
 * Canonical Organization snippet — drop on the homepage and any page that
 * benefits from clarifying "who is Caseflow." Anything that needs to
 * change in one place (logo URL, social links) belongs here.
 */
export const organizationSchema = () => ({
  '@type': 'Organization',
  name: 'Caseflow',
  description: 'Case management for migration agencies, education agencies, law firms and real estate agencies.',
  url: 'https://caseflow.app',
  logo: 'https://caseflow.app/og-image.png',
  sameAs: [
    // Drop your real social URLs here when they're set up.
  ],
})
